import React from 'react'
import Svg from '../Svg'
import { SvgProps } from '../types'

const Icon: React.FC<SvgProps> = (props) => (
    <Svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <rect x="0.161163" y="16.5563" width="22" height="3" rx="1.5" transform="rotate(-45 0.161163 16.5563)" fill="white"/>
        <rect x="2.28247" y="0.661163" width="22" height="3" rx="1.5" transform="rotate(45 2.28247 0.661163)" fill="white"/>
    </Svg>


)

export default Icon